import { useState } from "react";
import { ScaleLoader } from "react-spinners";
import { getMainTheme } from "../../../../core/utils/theme";
import { CFlex, Column, DeleteIcon, Flex, Row } from "../../../../styles/CommonStyles";
import Text from "../../../../core/utils/Text";
import { EditIcon } from "../../../../styles/main/setting";
import ModalLayout from "../../../layout/main/ModalLayout";
import PackageModal from "./PackageModal";

const packageAttributes = {
    headers: [
        { title: "label" },
        { title: "description" },
        { title: "options" },
        { title: "levelNumber" },
        { title: "price" },
        { title: "expireDays" },
        { title: "maxUse" },
        { title: "status" },
        { title: "action" },
    ],
    cs: "1fr 2fr 2fr 0.6fr  1.2fr 0.8fr 0.5fr 0.6fr 0.5fr",
};

const PackageListing = ({ packages, isLoading }) => {

    const { headers, cs } = packageAttributes;

    const initialModal = { show: false, pkg: null, type: "edit" };
    const [packageModal, setPackageModal] = useState(initialModal);

    const closePackageModal = () => setPackageModal(initialModal);
    const openPackageModal = (pkg, type = "edit") =>
        setPackageModal({ show: true, pkg, type });

    return (
        <>
            <CFlex fw>
                {isLoading ? (
                    <Flex height={"300px"} justify="center" align="center">
                        <ScaleLoader color={getMainTheme().active} />
                    </Flex>
                ) : (
                    <>
                        <Row cs={cs} header={1}>
                            {headers.map((h) => (
                                <Column key={h.title}>
                                    <Text tid={h.title} />
                                </Column>
                            ))}
                        </Row>

                        {packages.map((pkg, idx) => (
                            <Row cs={cs} index={idx} key={pkg.id} noHover={1}>
                                <Column>{pkg.label}</Column>
                                <Column>{pkg.description || "—"}</Column>
                                <Column>
                                    <Flex fw wrap justify={"flex-start"}>
                                        {pkg.options?.slice(0, 3).map((opt, i) => (
                                            <Flex
                                                key={i}
                                                style={{
                                                    border: "1px solid #444",
                                                    borderRadius: "6px",
                                                    padding: "2px 6px",
                                                    margin: "2px",
                                                    fontSize: "12px",
                                                }}
                                            >
                                                {opt}
                                            </Flex>
                                        ))}
                                    </Flex>
                                </Column>
                                <Column>{pkg.levelNumber}</Column>
                                <Column>
                                    {pkg.priceAmount} {pkg.priceCurrency}
                                    {pkg.priceAmountBeforeOff
                                        ? ` (${pkg.priceAmountBeforeOff})`
                                        : ""}
                                </Column>
                                <Column>{pkg.expireDays || "∞"}</Column>
                                <Column>{pkg.maxUse || "0"}</Column>
                                <Column>
                                    {pkg.isActive ? (
                                        <Text tid={"active"} color={"green"} />
                                    ) : (
                                        <Text tid={"inactive"} color={"red"} />
                                    )}
                                </Column>
                                <Column>
                                    <Flex gap="8px">
                                        <EditIcon size={22} onClick={() => openPackageModal(pkg, "edit")} />
                                        <DeleteIcon
                                            size={22}
                                            color="#d33"
                                            onClick={() => openPackageModal(pkg, "delete")}
                                        />
                                    </Flex>
                                </Column>
                            </Row>
                        ))}
                    </>
                )}
            </CFlex>

            {/* Modal reused for both Edit and Delete actions */}
            <ModalLayout
                width={packageModal.type === "delete" ? "420px" : "620px"}
                open={packageModal.show}
                onClose={closePackageModal}
            >
                <PackageModal
                    onSuccess={closePackageModal}
                    _package={packageModal.pkg}
                    existingPackages={packages}
                    type={packageModal.type}
                />
            </ModalLayout>
        </>
    );
};

export default PackageListing;
